import { ViewMode } from '@40seas/entities/common';
import { getTenantDisplayName } from '@40seas/entities/tenants';

export const isOrganizationDefaultTenant = (organizationName: string, tenantId: string) => {
    return organizationName.toLowerCase() === tenantId.toLowerCase();
};

export const organizationSlugProvider = {
    get: ({
        organizationName,
        tenant,
        viewMode,
    }: {
        organizationName: string;
        tenant: string | undefined;
        viewMode: ViewMode | undefined;
    }): string =>
        organizationName
            ? `/${organizationName}${
                  tenant && viewMode !== ViewMode.Buyer && !isOrganizationDefaultTenant(organizationName, tenant)
                      ? `/${getTenantDisplayName(tenant, organizationName)}`
                      : ''
              }`.toLowerCase()
            : '',
};
